<template>
    <div class="product">
        <banner title="主营业务"/>
        <div class="product-content">
            <div class="nomove">
                <div class="top">
                    <h3>不动产测绘</h3>
                    <p>Real Estate</p>
                    <div class="border"></div>
                </div>
                <div class="nomove-list">
                    <div class="nomove-list-img">
                        <img src="../assets/img/move1.png" alt="">
                    </div>
                    <p>公司具有乙级测绘资质（乙测资质5010735），具有较为雄厚的技术力量和先进仪器设备。配备了GPS卫星定位系统、高精度进口全站仪、手持测距仪、绘图仪、扫描仪及成图软件等仪器设备。主要承接的工程项目有：基坑监测、建筑物沉降监测、控制测量、地形测量、城乡用地测量、市政工程测量、线路工程测量、桥梁测量、隧道测量、土石方面积测量、竣工测量等各类工程测量，地籍测绘、房产测绘等。</p>
                </div>
            </div>
             <el-divider></el-divider>
            <div class="airphoto">
                <div class="top">
                    <h3>航空摄影</h3>
                    <p>Airphoto</p>
                    <div class="border"></div>
                </div>
                <div class="airphoto-list">
                    <p>无人机可通过相机、激光雷达等控制设备来进行测量，并且可以预设航线，在作业区域上空自动作业采集数据，采集完数据后可导入本公司自主研发的系统，一键生成点云及三维模型数据，并据此进行空间距离、体积的测量，或者进行斜面等不规则堆体面积的模拟测量，为工程建设规划和生产作业等提供精确数值参考。人工测绘作业，不仅效率低、难度大、危险系数高，而且检测精细度远远不够，而无人机技术的应用，将在很大程度上解决了这一难题。</p>
                    <div class="airphoto-img">
                        <img src="../assets/img/move2.png" alt="">
                        <img src="../assets/img/move3.png" alt="">
                        <img src="../assets/img/move4.png" alt="">
                    </div>
                    </div>
            </div>
            <el-divider></el-divider>
            <div class="gismap">
                <div class="top">
                    <h3>地理信息系统</h3>
                    <p> Geosystem</p>
                    <div class="border"></div>
                </div>
                <div class="gismap-list">
                    <p>公司自主研发的地理信息管理系统软件，将无人机测量和传统测绘相结合，建立完善数据库，是行业内少有的数据整合系统。我司将此软件功能进行了延伸，研发出了“重庆市园区建设管理系统”和“重庆市土地巡查看护系统”，这将给客户带来便捷与高效。</p>
                    <div class="gismap-list-img">
                        <img src="../assets/img/cass6.jpg" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Banner from '../components/Banner'
export default {
    components:{
        Banner
    }
}
</script>
<style lang="scss" scoped>
.product{
    width: 100%;
    height: 100%;
    background-color:#14679f ;
    &-content{
        width: 1240px;
        min-height: 1000px;
        margin: 0 auto;
        background-color: #fff;
    }
}
.nomove{
    padding-top: 90px;
    &-list{
        width: 100%;
        height: 600px;
        display: flex;
        justify-content: center;
        align-items: center;

        p{
            width: 60%;
            line-height: 30px;
            padding: 0 70px;
            font-size: 22px;
            text-indent: 43px;
        }
    }
}
.airphoto{
    padding: 10px 10px;
    &-list{
        width: 100%;
        height: 450px;
        vertical-align: middle;
        p{
            width: 80%;
            line-height: 30px;
            font-size: 18px;  
            margin: 0 auto;
            text-indent: 35px;
            margin-top: 30px;
        }
        .airphoto-img{
            display: flex;
            justify-content: center;
            align-content: center;
            img{
              width: 30%;
              height: 300px;
            }
        }
    }
}
.gismap{
    padding-top: 50px;
    &-list{
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        p{
            width: 45%;
            line-height: 30px;
            padding: 0 70px;
            font-size: 18px;
            text-indent: 35px;
        }
        &-img{
            width: 50%;
            // margin: 0 30px;
        }
    }
}

.top {
    h3,
    p {
        text-align: center;
        color: #3c6088;
        font-weight: 400;
        padding: 10px 0;
    }
    h3 {
        font-size: 30px;
    }
    p {
        font-size: 20px;
    }
    .border {
        border-bottom: 1px solid #3c6088;
        width: 15%;
        margin: 0 auto;
    }
}
</style>